import React from 'react';
import AccordionItem from 'shared/components/UC/AccordionItem';
import styles from './ExpandableSection.module.css';

interface ExpandableSectionProps {
  id: string;
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

// Thin adapter over the kit's AccordionItem (uc-collapse / uc-card) so the
// reading column uses the canonical kit accordion format, while keeping the
// panel's controlled open/close per section.
const ExpandableSection: React.FC<ExpandableSectionProps> = ({
  id,
  title,
  isExpanded,
  onToggle,
  children,
}) => {
  return (
    <AccordionItem
      id={id}
      title={title}
      isOpen={isExpanded}
      onToggle={onToggle}
      toggleTextClosed="Ver más"
      toggleTextOpen="Ver menos"
      className={styles.section}
    >
      {children}
    </AccordionItem>
  );
};

export default ExpandableSection;
